// imports
document.documentElement.className = 'js';

window.mobile = (window.matchMedia("(max-width: 1024px)").matches) ? true : false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    window.mobile = true;
}


const timeline = gsap.timeline();

import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';
import './polyfill/arrayFrom';
import './polyfill/arrayFind';
import './polyfill/dataset';
import { gsap } from "gsap";
import barba from '@barba/core';
// import Rgpd from './modules/rgpd';
import * as Header from './modules/header';
import * as Utils from './modules/utils.js';
import * as Modal from './modules/modal.js';

import rgpd from './modules/rgpd';


const appHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

window.addEventListener("load", () => {
    Utils.storageDeleteValue('data-topics');
    Utils.storageDeleteValue('data-messages');

    // rgpd(cat => {
    //     if (cat == 'stats') {
    //         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    //         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    //         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    //         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    //         })(window,document,'script','dataLayer','GTM-KG4553G');
    //     }
    // });

    Header.init();
    hash();

    // barba transitions things
    barba.init({
        sync: true,
        transitions: [
            // to contact
            {
                to: {
                    namespace: ['topics', 'messages'],
                },
                async leave() {
                    timeline
                        .to(document.body, { opacity: '0', duration: 0.5 });
                    const done = this.async();
                    await delay(1000);
                    Header.transparent(false);
                    Header.close();
                    done();
                },
                enter() {
                },
                once() {
                    conditioner.hydrate(document.documentElement);
                    timeline.to(document.body, { opacity: '1', duration: 0.5 });
                }
            },
            // default
            {
                async leave() {
                    timeline
                        .to(document.body, { opacity: '0', duration: 0.5 });
                    const done = this.async();
                    await delay(1000);
                    Header.transparent();
                    Header.close();
                    done();
                },
                enter() {
                },
                once() {
                    conditioner.hydrate(document.documentElement);
                    timeline.to(document.body, { opacity: '1', duration: 0.5 });
                }
            }
        ]
    });

    barba.hooks.after(() => {

        window.scrollTo({
            top: 0,
            behavior: 'instant'
        });

        conditioner.hydrate(document.querySelector('main'));

        Modal.update();
        hash();

        if (document.activeElement) {
            document.activeElement.blur();
        }
    });

    barba.hooks.leave(() => {
    });

    barba.hooks.enter(() => {        
        timeline.to(document.body, { opacity: '1', duration: 0.5 });
    })
});

function hash() {
    const hash = window.location.hash;
    if (hash) {
        const el = document.querySelector(hash);
        if (el) {
            el.scrollIntoView({behavior: "smooth"});
        }
    }
}

function delay(n) {
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n)
    })
}

conditioner.addPlugin({
    monitor: {
        name: 'visible',
        create: (context, element) => ({
            matches: false,
            addListener(change) {
                new IntersectionObserver((entries) => {
                    this.matches = entries.pop().isIntersecting === context;
                    change();
                }).observe(element);
            },
        }),
    },
    moduleSetName: (name) => `./modules/${name}.js`,
    moduleGetConstructor: (module) => module.default,
    moduleImport: (name) => import( /* webpackMode: "lazy" */ `${name}`),
});
// conditioner.hydrate(document.documentElement);
